import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { MenuModule } from '@syncfusion/ej2-angular-navigations';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { MessageService } from './message';
import { FeedModule } from './feed/feed.module';
import { WordpressResourcesComponent } from './wordpress-resources/wordpress-resources.component';


@NgModule({
  declarations: [
    AppComponent,
    WordpressResourcesComponent
  ], 
  imports: [
    HttpClientModule,
    BrowserModule,
    DropDownListModule,
    MenuModule,
    AppRoutingModule,
    LayoutModule, 
    FeedModule,
    RouterModule.forRoot([]) 
  ],
  providers: [
    MessageService,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { 
}
